import { Component, Vue, Watch } from "vue-property-decorator";
import { gql } from "graphql-tag";
import { CPRS_RENEWAL_APPLICATION_FORM_QUERY } from "@/graphql/cprs-renewal-application-query";
import RadioButtonComponent from "../radio-button/radio-button.component.vue";
import CheckboxButtonComponent from "../checkbox-button/checkbox-button.component.vue";
import FileUploadComponent from "../file-upload/file-upload.component.vue";
import InputOtherComponent from "../input-other/input-other.component.vue";
import SignatureSubmissionComponent from "../signature-submission/signature-submission.component.vue";
import { renewalFormApi } from "@/providers/apis/cprs-renewal-application";
import { utils } from "@/utils/utils";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import moment from "moment";
import {
  FormFieldContents,
  FormNavbar,
  RenewalApplicationsForm,
  formtInputData,
  trainingForm,
} from "@/models/cprs-renewal-application/cprs-renewal-application.interface";
import ScopeOfActivity from "../scope-of-activity/scope-of-activity-component.vue";
import RenewalPreviewFormComponent from "../renewal-preview-form/renewal-preview-form.component.vue";
import { certificationFormApi } from "@/providers/apis/certification-part-two-form";
import ErrorPopupComponent from "../error-popup/error-popup.component.vue";
import { RENEWAL_REMAINDER } from "@/graphql/renewal_remainder-query";
import { RenewalRemainders } from "@/models/renewal-remainder/renewal-remainder.interface";
import FormInputDatepickerComponent from "../form-input-datepicker/form-input-datepicker.component.vue";
import { applicantDetialsApi } from "@/providers/apis/applicant-dashboard";
import PreviewPopupComponent from "../preview-popup/preview-popup.component.vue";

@Component({
  name: "renewal-form",
  components: {
    "b-form-radio-group": RadioButtonComponent,
    "b-form-checkbox": CheckboxButtonComponent,
    "b-form-upload-file": FileUploadComponent,
    "b-form-checkbox-input": InputOtherComponent,
    "b-form-signature-submission": SignatureSubmissionComponent,
    "b-form-renewal-preview-form": RenewalPreviewFormComponent,
    "code-of-ethics-and-scope-of-activity": ScopeOfActivity,
    "b-form-input-datepicker": FormInputDatepickerComponent,
    AppLoaderComponent,
    ErrorPopupComponent,
    PreviewPopupComponent,
  },
})
export default class CprsRenewalApplicationComponent extends Vue {
  public applicationData: Array<RenewalApplicationsForm> = [];
  public formData: Array<FormFieldContents> = [];
  public applicationNavData: Array<FormNavbar> = [];
  public formPagination = 0;
  public isNavLoad = false;
  public isScroll = false;
  public isValid = false;
  public addTrainingForm: trainingForm[] = [];
  public renewalLocationId: any;
  public currentForm: any;
  public fileData: any;
  public saveDataDraft = false;
  public formName = "renewalApplicationInformation";
  public formTitle = {
    programTitle: "",
    formTitle: "",
  };
  public renewalPayLoadData: any = {
    id: "",
    fillStatus: "DRAFT",
    renewalApplicationInformation: {
      firstName: "",
      lastName: "",
      certificationNumber: "",
      certificateExpirationDate: "",
      addressLine1: "",
      addressLine2: "",
      state: "",
      city: "",
      zip: "",
      phone: "",
      email: "",
      agencyOrOrganization: "",
      position: "",
      status: [],
    },
    renewalTrainingInformation: [],
    renewalSupervisorInformation: [
      {
        supervisorFirstName: "",
        supervisorLastName: "",
        supervisorAgencyOrganization: "",
        supervisorPhone: "",
        supervisorEmail: "",
      },
    ],
    renewalHandbook: {
      handbook: {
        codeOfEthics: {
          isCodeofEthicsChecked: [],
          codeofEthicsFirstName: "",
          codeofEthicsLastName: "",
        },
        scopeOfActivity: {
          isScopeofActivityChecked: [],
          scopeofActivityFirstName: "",
          scopeofActivityLastName: "",
        },
      },
    },
    renewalSignatureSubmission: {
      isSignature: "",
      submissionDate: moment().format("MM-DD-YYYY"),
    },
  };
  public isTrainingReferesh = "false";
  public isTrainingSaved = true;
  public notSavedTrainingIndex: number[] = [];
  public userDetails: any;
  public isReviewerUser: any;
  public applicantFullDetials: any;
  public formCompletedIndex: number[] = [];
  public signatureInvalid = false;
  public checkValidForm = false;
  public mainId = "app";
  public eventBind: any = {
    acceptNumberOnly: this.numberValidation,
    telCharacter: this.telCharacterValidate,
    onlyAlphabets: this.onlyAlphabets,
  };
  public isFileValid = false;
  public notFilesUploadedKeyNames: string[] = [];
  public isLoading = true;
  public isEdit = false;
  public currentRoute = "";
  public checkSOAValid = false;
  public validSOA = true;
  public trainingDuplicateIndexs: number[] = [];
  public isNavigatefromUserDashboard = false;
  public disableFiled = ["certificationNumber", "certificateExpirationDate"];
  public errorMessage = "";
  public supervisorFormFields: formtInputData[] = [];
  public tempSupervisorFormFields: formtInputData = {} as formtInputData;
  public supervisorUIUpdate = false;
  public supervisorEmailDuplicateIndexs: number[] = [];
  public renewalRemainder: RenewalRemainders = {} as RenewalRemainders;
  public educationLists: any;
  public imgType = ["jpg", "png", "jpeg", "tiff"];
  public S3Path = "";
  public previewFile: any[] = [];
  public showPreviewPopup = false;
  public seletedTraning: any[] = [];
  public trainingIndex = 2;
  public isAvailableTraining = false;
  public availableTraining: any[] = [];
  public async created() {
    await this.$apollo
      .query({
        query: gql`query ${RENEWAL_REMAINDER}`,
      })
      .then((result) => {
        const remainders: any[] = result.data.renewalReminders.data;
        if (remainders.length) {
          const remaindersData = remainders.find(
            (data) => data.attributes.reminder_seq === 1
          );
          this.renewalRemainder = remaindersData.attributes;
        }
      });

    this.currentRoute = this.$route.fullPath;
    this.userDetails = utils.getUserDetails();
    const token = localStorage.getItem("access_token");
    if (this.userDetails) {
      const userRolesData = this.userDetails.roles;
      this.isReviewerUser =
        userRolesData && userRolesData.indexOf("REVIEWER") !== -1;
    } else {
      this.isReviewerUser = false;
    }
    let payloadStorage: any = localStorage.getItem("renewalPayLoadData");
    if (payloadStorage) {
      payloadStorage = JSON.parse(payloadStorage);
      this.renewalPayLoadData = {
        ...this.renewalPayLoadData,
        ...payloadStorage,
      };
    }
    if (!this.$route.query.isDraft) {
      if (this.$route.query.id) {
        this.isNavigatefromUserDashboard = true;
        const applicantId: string = this.$route.query.id as string;
        if (
          !this.isReviewerUser &&
          token &&
          (this.userDetails.roles === null || !this.userDetails.roles)
        ) {
          await certificationFormApi
            .getCertificationApplicationForm(applicantId)
            .then((result: any) => {
              this.storeBasicDetais(result.data);
            })
            .catch((error) => {
              this.errorMessage = utils.errorMessage(error);
              this.isLoading = false;
            });
        } else {
          if (!payloadStorage) {
            this.$router.push({
              name: "login-page",
              query: { application: "renewal-form" },
            });
          }
        }
      } else {
        if (
          !this.isReviewerUser &&
          token &&
          (this.userDetails.roles === null || !this.userDetails.roles)
        ) {
          const userDetailsEmail = this.userDetails.email;
          await renewalFormApi
            .getApplicantDetials(userDetailsEmail)
            .then((result: any) => {
              this.applicantFullDetials = result.data;
              this.storeBasicDetais(this.applicantFullDetials, true);
              // Application Information arrives pre-filled — create the draft on
              // the minimum (name/email/zip) so navigation is unlocked at once.
            })
            .catch((error) => {
              this.errorMessage = utils.errorMessage(error);
              this.isLoading = false;
            });
        } else {
          if (!payloadStorage) {
            this.$router.push({
              name: "login-page",
              query: { application: "renewal-form" },
            });
          }
        }
      }
    }
    const formFilledIndex: any = localStorage.getItem("renewalFormFilledIndex");
    if (formFilledIndex) {
      formFilledIndex.split(",").forEach((data: string) => {
        this.formCompletedIndex.push(Number(data));
      });
    }
    // Re-derive step 0 completion from a live validation so a stale mark can't
    // make the finalize gate skip an unfinished Application Information tab.
    this.syncStepZeroOnLoad();
    if (this.formPagination === 0) {
      this.isNavLoad = true;
    }
    this.$apollo
      .query({
        query: gql`query ${CPRS_RENEWAL_APPLICATION_FORM_QUERY}`,
      })
      .then((result) => {
        this.applicationData = result.data.cprsRenewalApplications.data;
        this.formTitle = {
          programTitle: this.applicationData[0].attributes.programTitle,
          formTitle: this.applicationData[0].attributes.formTitle,
        };
        this.applicationNavData =
          this.applicationData[0].attributes.RenewalNavbar;
        this.formData = this.applicationData[0].attributes.form_fields;
        this.tempSupervisorFormFields = JSON.parse(
          JSON.stringify(
            this.applicationData[0].attributes.form_fields[2].fields
              .formInputs[0]
          )
        );
        if (this.renewalPayLoadData.renewalSupervisorInformation.length) {
          const addSupervisorForm =
            this.renewalPayLoadData.renewalSupervisorInformation.length;
          for (let index = 0; index < addSupervisorForm; index++) {
            this.supervisorFormFields.push(this.tempSupervisorFormFields);
          }
        }
        this.isLoading = false;
        // Arm autosave only now: everything above is the form loading itself,
        // not the applicant filling it in.
        this.$nextTick(() => {
          this.startDraftAutoSave();
        });
      });
    const el = document.getElementById("header");
    if (el) {
      el.classList.add("remove-container");
    }
    this.getTraningDetail();
  }
  public mounted() {
    const mainEl: any = document.querySelector(".main-content");
    if (mainEl) {
      mainEl.addEventListener("keyup", (event: any) => {
        if (event.shiftKey && event.keyCode == 9) {
          const el = event.path[0];
          if (el) {
            el.scrollIntoView({ block: "center", behavior: "smooth" });
          }
        }
      });
    }
  }
  public storeBasicDetais(basicdetails: any, isTrainingData = false) {
    this.renewalPayLoadData.renewalApplicationInformation.certificationNumber =
      utils.renewalValueSetter(
        this.renewalPayLoadData,
        "renewalApplicationInformation",
        "certificationNumber",
        basicdetails,
        "certificateNumber"
      );

    this.renewalPayLoadData.renewalApplicationInformation.certificateExpirationDate =
      utils.renewalValueSetter(
        this.renewalPayLoadData,
        "renewalApplicationInformation",
        "certificateExpirationDate",
        basicdetails,
        "expiryDate"
      );

    this.renewalPayLoadData.renewalApplicationInformation.firstName =
      utils.renewalValueSetter(
        this.renewalPayLoadData,
        "renewalApplicationInformation",
        "firstName",
        basicdetails,
        "firstName"
      );

    this.renewalPayLoadData.renewalApplicationInformation.lastName =
      utils.renewalValueSetter(
        this.renewalPayLoadData,
        "renewalApplicationInformation",
        "lastName",
        basicdetails,
        "lastName"
      );

    this.renewalPayLoadData.renewalApplicationInformation.phone =
      utils.renewalValueSetter(
        this.renewalPayLoadData,
        "renewalApplicationInformation",
        "phone",
        basicdetails.data,
        "phone",
        isTrainingData
          ? "certificationPartOneBasicDetails"
          : "certificationPartTwoApplicationForm"
      );

    this.renewalPayLoadData.renewalApplicationInformation.email =
      utils.renewalValueSetter(
        this.renewalPayLoadData,
        "renewalApplicationInformation",
        "email",
        basicdetails.data,
        "email",
        isTrainingData
          ? "certificationPartOneBasicDetails"
          : "certificationPartTwoApplicationForm"
      );

    this.renewalPayLoadData.renewalApplicationInformation.addressLine1 =
      utils.renewalValueSetter(
        this.renewalPayLoadData,
        "renewalApplicationInformation",
        "addressLine1",
        basicdetails.data,
        "addressLine1",
        isTrainingData
          ? "certificationPartOneBasicDetails"
          : "certificationPartTwoApplicationForm"
      );

    this.renewalPayLoadData.renewalApplicationInformation.addressLine2 =
      utils.renewalValueSetter(
        this.renewalPayLoadData,
        "renewalApplicationInformation",
        "addressLine2",
        basicdetails.data,
        "addressLine2",
        isTrainingData
          ? "certificationPartOneBasicDetails"
          : "certificationPartTwoApplicationForm"
      );

    this.renewalPayLoadData.renewalApplicationInformation.state =
      utils.renewalValueSetter(
        this.renewalPayLoadData,
        "renewalApplicationInformation",
        "state",
        basicdetails.data,
        "state",
        isTrainingData
          ? "certificationPartOneBasicDetails"
          : "certificationPartTwoApplicationForm"
      );

    this.renewalPayLoadData.renewalApplicationInformation.city =
      utils.renewalValueSetter(
        this.renewalPayLoadData,
        "renewalApplicationInformation",
        "city",
        basicdetails.data,
        "city",
        isTrainingData
          ? "certificationPartOneBasicDetails"
          : "certificationPartTwoApplicationForm"
      );

    this.renewalPayLoadData.renewalApplicationInformation.zip =
      utils.renewalValueSetter(
        this.renewalPayLoadData,
        "renewalApplicationInformation",
        "zip",
        basicdetails.data,
        "zip",
        isTrainingData
          ? "certificationPartOneBasicDetails"
          : "certificationPartTwoApplicationForm"
      );
  }

  public fileSave(fileData: any, index: number) {
    this.isFileValid = !this.isFileValid;
    this.$validator.validateAll().then(async (validate) => {
      if (validate && !this.notFilesUploadedKeyNames.length) {
        this.isTrainingReferesh = this.changeStateForTraining(
          this.isTrainingReferesh
        );
        const findIndex = this.notSavedTrainingIndex.indexOf(index);
        this.notSavedTrainingIndex.splice(findIndex, 1);
        localStorage.setItem(
          "renewalPayLoadData",
          JSON.stringify(this.renewalPayLoadData)
        );
      } else {
        setTimeout(() => {
          const el = document.getElementsByClassName("is-invalid")[0];
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "end" });
          }
        }, 10);
      }
    });
  }

  public scopeOfActivityValidation(event: boolean) {
    this.validSOA = event;
  }

  public nextButton() {
    this.checkValidForm = true;
    this.isFileValid = !this.isFileValid;
    this.checkSOAValid = !this.checkSOAValid;
    // Finalizing from the signature step must not skip earlier steps: if any is
    // incomplete (free-nav jumped past it), send the user back to it.
    if (this.formPagination === 4) {
      const incomplete = this.firstIncompleteDataStep();
      if (incomplete !== -1 && incomplete !== 4) {
        this.jumpToIncompleteStep(incomplete);
        return;
      }
    }
    this.renewalPayLoadData.renewalApplicationInformation.state =
      this.renewalPayLoadData.renewalApplicationInformation.state.toLocaleUpperCase();
    if (this.formPagination === 1) {
      this.trainingDuplicateIndexs = this.duplicateRowIdx(
        "renewalTrainingInformation",
        "trainingName"
      );
      if (this.trainingDuplicateIndexs.length) {
        this.formPagination = 1;
        this.formName = "renewalTrainingInformation";
        setTimeout(() => {
          const el = document.getElementsByClassName("is-invalid")[0];
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "end" });
          }
        }, 50);
        return;
      }
    }

    if (this.formPagination === 2) {
      this.supervisorEmailDuplicateIndexs = utils.duplicateValueIdx(
        this.renewalPayLoadData,
        this.formName,
        true,
        "supervisorEmail"
      );
      if (this.supervisorEmailDuplicateIndexs.length) {
        this.formPagination = 2;
        this.formName = "renewalSupervisorInformation";
        setTimeout(() => {
          const el = document.getElementsByClassName("is-invalid")[0];
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "end" });
          }
        }, 50);
        return;
      }

      const supervisorEmailValidate =
        this.renewalPayLoadData.renewalSupervisorInformation.filter(
          (supervisor: any) => {
            if (
              supervisor.supervisorEmail.toLowerCase() ===
              this.renewalPayLoadData.renewalApplicationInformation.email.toLowerCase()
            ) {
              return supervisor;
            }
          }
        );

      if (supervisorEmailValidate.length) {
        this.errorMessage =
          "Supervisor email id and applicant email id must be different *";
        return;
      }
    }

    if (this.formPagination == 4) {
      this.renewalPayLoadData.renewalSignatureSubmission.submissionDate =
        moment().format("MM-DD-YYYY");
      if (this.renewalPayLoadData.renewalSignatureSubmission.isSignature) {
        this.signatureInvalid = false;
      } else {
        this.checkValidForm = true;
        this.signatureInvalid = true;
        setTimeout(() => {
          const el = document.getElementsByClassName("is-invalid")[0];
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "end" });
          }
        }, 10);
        return;
      }
    }

    this.$validator.validateAll().then(async (validate) => {
      if (
        this.supervisorEmailDuplicateIndexs.length === 0 &&
        !this.notSavedTrainingIndex.length &&
        validate &&
        !this.notFilesUploadedKeyNames.length &&
        this.validSOA &&
        this.trainingDuplicateIndexs.length === 0
      ) {
        // The step completed NOW, before nextPaginationUpdate() advances it.
        const completedStep = this.formPagination;
        // Find Days count between Expiry Date and Current Date
        const startDate = moment(moment(new Date()).format("MM-DD-YYYY"));
        const endDate = moment(
          moment(
            this.renewalPayLoadData.renewalApplicationInformation
              .certificateExpirationDate
          ).format("MM-DD-YYYY")
        );
        const daysCount = Math.floor(endDate.diff(startDate, "days"));
        if (daysCount > this.renewalRemainder.days) {
          this.errorMessage = `You can't fill renewal application now for this certificate. Please try before ${this.renewalRemainder.days} days to expire.`;
          this.formPagination = 0;
          this.formName = "renewalApplicationInformation";
          return;
        }
        this.isLoading = true;
        this.checkValidForm = false;
        this.isValid = true;
        if (
          this.formName === "renewalTrainingInformation" &&
          this.educationLists &&
          this.educationLists.length
        ) {
          this.renewalPayLoadData.renewalTrainingInformation =
            this.renewalPayLoadData.renewalTrainingInformation.filter(
              (data: any) => {
                return data.isNew;
              }
            );
          this.educationLists.filter((traning: any) => {
            if (traning.isChecked) {
              const data = {
                trainingName: traning.title,
                proofOfAttendance: traning.attachments,
                trainingDuration: traning.trainingHours,
                trainingFormat:
                  traning && traning.trainingFormat
                    ? traning.trainingFormat
                    : "",
                isNew: false,
                isChecked: traning.isChecked,
              };
              this.renewalPayLoadData.renewalTrainingInformation.push(data);
            }
          });
        }
        // An autosave may be pending or in flight. Drop the pending one and wait
        // for the running one, so this updates the row the autosave created
        // instead of racing it and creating a second application.
        if (this.draftAutoSaveTimer) {
          clearTimeout(this.draftAutoSaveTimer);
          this.draftAutoSaveTimer = null;
        }
        await this.draftSave;
        if (!this.renewalPayLoadData.id) {
          await renewalFormApi
            .RenewalApplicationForm(
              this.renewalPayLoadData.fillStatus,
              this.renewalPayLoadData
            )
            .then((result: any) => {
              this.isLoading = false;
              this.renewalLocationId = result.headers.location;
              localStorage.setItem(
                "renewalApplicationId",
                this.renewalLocationId
              );
              this.renewalPayLoadData.id = localStorage.getItem(
                "renewalApplicationId"
              );
              localStorage.setItem(
                "renewalPayLoadData",
                JSON.stringify(this.renewalPayLoadData)
              );
              if (!this.isEdit) {
                this.nextPaginationUpdate();
              }
              const el = document.getElementById(this.mainId);
              if (el) {
                el.scrollIntoView({ behavior: "smooth" });
              }
            })
            .catch((error) => {
              this.errorMessage = utils.errorMessage(error);
              this.isLoading = false;
            });
        } else {
          const id = this.renewalPayLoadData.id;
          await renewalFormApi
            .updateRenewalForm(this.renewalPayLoadData, id)
            .then((data) => {
              this.isLoading = false;
              if (!this.isEdit) {
                this.nextPaginationUpdate();
              }
              const el = document.getElementById(this.mainId);
              if (el) {
                el.scrollIntoView({ behavior: "smooth" });
              }
            })
            .catch((error) => {
              this.errorMessage = utils.errorMessage(error);
              this.isLoading = false;
            });
          localStorage.setItem(
            "renewalPayLoadData",
            JSON.stringify(this.renewalPayLoadData)
          );
          if (this.isEdit) {
            this.formPagination = 5;
            this.formName = "renewalApplicationInformation";
          }
        }
        if (!this.formCompletedIndex.includes(completedStep)) {
          this.formCompletedIndex.push(completedStep);
        }
        this.currentForm = this.renewalPayLoadData[this.formName];
        localStorage.setItem(
          "renewalFormFilledIndex",
          this.formCompletedIndex.toString()
        );
      } else {
        setTimeout(() => {
          const el = document.getElementsByClassName("is-invalid")[0];
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "end" });
          }
        }, 10);
      }
    });
  }

  // Validate every data step's mandatory fields before Preview. vee-validate
  // only sees the on-screen step, so we render each step in turn and stop on the
  // first invalid one — landing on that tab and scrolling to the error.
  private dataStepSlugs: string[] = [
    "renewalApplicationInformation",
    "renewalTrainingInformation",
    "renewalSupervisorInformation",
    "renewalHandbook",
    "renewalSignatureSubmission",
  ];

  // Render a step's special content (the Training tab builds its list on entry).
  private renderStep(slug: string) {
    if (slug === "renewalTrainingInformation") {
      const renewalFormData =
        this.renewalPayLoadData.renewalTrainingInformation;
      if (renewalFormData.length) {
        this.showTrainingForm();
      }
      this.setAvailableTraining();
    }
  }

  // First data step not yet completed via Next, or -1 if all are done. Preview is
  // only reachable when this returns -1.
  private firstIncompleteDataStep(): number {
    for (let i = 0; i < this.dataStepSlugs.length; i++) {
      if (!this.formCompletedIndex.includes(i)) {
        return i;
      }
    }
    return -1;
  }

  // Land on an incomplete step and scroll to the first missing required field.
  private jumpToIncompleteStep(index: number) {
    this.isEdit = false;
    this.supervisorEmailDuplicateIndexs = [];
    this.formName = this.dataStepSlugs[index];
    this.formPagination = index;
    this.checkValidForm = true;
    this.isFileValid = !this.isFileValid;
    this.renderStep(this.formName);
    this.$nextTick(() => {
      this.$validator.validateAll().then(() => {
        setTimeout(() => {
          const invalid = document.getElementsByClassName("is-invalid")[0];
          if (invalid) {
            invalid.scrollIntoView({ behavior: "smooth", block: "center" });
          } else {
            const el = document.getElementById(this.mainId);
            if (el) {
              el.scrollIntoView({ behavior: "smooth" });
            }
          }
        }, 100);
      });
    });
  }

  private validatorFieldCount(): number {
    try {
      const fields: any = (this.$validator as any).fields;
      return fields && fields.items ? fields.items.length : 0;
    } catch (e) {
      return 0;
    }
  }

  // The checks Next runs on a step that vee-validate cannot see, so a silent
  // re-derivation judges a step exactly as Next would. Side-effect free: the
  // duplicate lookups are read here and thrown away rather than written to the
  // *DuplicateIndexs fields, because this runs while the user is on their way
  // to another tab and must not light up errors behind them.
  /**
   * Payload rows come back from drafts that were saved by older shapes, so a
   * key can simply be absent. A bare .toLowerCase() on one of those throws, and
   * because these checks run inside navigateTab the throw took the tab click
   * with it — the click did nothing at all, with nothing in the console to say
   * why. Everything below reads through these two instead.
   */
  private lower(value: any): string {
    return typeof value === "string" ? value.toLowerCase() : "";
  }

  private duplicateRowIdx(section: string, field: string): number[] {
    const rows = this.renewalPayLoadData[section];
    if (!Array.isArray(rows)) {
      return [];
    }
    const seen = new Set<string>();
    const duplicates: number[] = [];
    rows.forEach((row: any, idx: number) => {
      const value = this.lower(row && row[field]);
      if (!value) {
        return;
      }
      if (seen.has(value)) {
        duplicates.push(idx);
      } else {
        seen.add(value);
      }
    });
    return duplicates;
  }

  /**
   * A refusal always has to say something. Validation errors and the messages
   * Next uses cover most of it, but a step can be held up by something with no
   * field to flag, and then the applicant is bounced to a tab that looks
   * perfectly fine and told nothing at all.
   */
  private announceBlockedStep(step: number) {
    setTimeout(() => {
      if (
        this.errorMessage ||
        document.getElementsByClassName("is-invalid").length
      ) {
        return;
      }
      const navName = (this.applicationNavData[step] || ({} as any)).name;
      const stepName = (navName || "").trim() || "this step";
      this.errorMessage = `Please complete ${stepName} before previewing the application.`;
    }, 300);
  }

  private stepExtraChecksPass(step: number): boolean {
    const payload = this.renewalPayLoadData;
    if (step === 1) {
      if (this.notSavedTrainingIndex.length) {
        return false;
      }
      return !this.duplicateRowIdx("renewalTrainingInformation", "trainingName")
        .length;
    }
    if (step === 2) {
      if (
        this.duplicateRowIdx("renewalSupervisorInformation", "supervisorEmail")
          .length
      ) {
        return false;
      }
      const applicantEmail = this.lower(
        (payload.renewalApplicationInformation || {}).email
      );
      return !(payload.renewalSupervisorInformation || []).some(
        (supervisor: any) =>
          this.lower(supervisor && supervisor.supervisorEmail) ===
          applicantEmail
      );
    }
    if (step === 3) {
      // The Scope of Activity lives on the handbook tab, so its validity is
      // that tab's business — not a reason to unmark any other one.
      return this.validSOA;
    }
    if (step === this.dataStepSlugs.length - 1) {
      return !!(payload.renewalSignatureSubmission || {}).isSignature;
    }
    return true;
  }

  // Mark the rendered data step complete only when every required field
  // validates; unmark it when a stale/minimal-only mark is left over. Validated
  // silently, errors cleared, so nothing flashes as the user leaves the tab.
  //
  // Every data step is re-derived, not just Application Information: a tab the
  // applicant filled in and then left by clicking another tab is finished
  // whether or not they pressed Next, and the Preview gate has to see that.
  // Without this, filling the last step and clicking Preview went nowhere — the
  // step was not marked, so the gate bounced the user straight back onto it.
  /**
   * Bring every step Preview is waiting on onto the screen and judge it exactly
   * as Next judges it. One that passes is marked and the walk moves on; the
   * first that genuinely fails is handed back so the applicant lands there with
   * its own errors showing.
   *
   * Preview is still only for an application that is actually finished — but
   * "finished" has to mean the data is there, not that the applicant happened to
   * press Next on every tab. Filling a tab and clicking Preview is a perfectly
   * ordinary thing to do, and it used to lead nowhere.
   *
   * Returns the step that blocks Preview, or -1 when nothing does.
   */
  private async settleIncompleteSteps(): Promise<number> {
    let step = this.firstIncompleteDataStep();
    if (step === -1) {
      return -1;
    }
    const landedOn = this.formPagination;
    this.isLoading = true;
    try {
      while (step !== -1) {
        if (!(await this.settleStep(step))) {
          return step;
        }
        const next = this.firstIncompleteDataStep();
        // A step that reports itself complete and still comes back as the first
        // incomplete one would spin here forever; stop and let the applicant see
        // it instead.
        if (next === step) {
          return step;
        }
        step = next;
      }
      return -1;
    } catch (error) {
      // The walk is a convenience, never a trap: if judging a step throws, put
      // the applicant back where they were rather than leaving the click dead.
      this.formPagination = landedOn;
      this.formName = this.dataStepSlugs[landedOn] || this.formName;
      return landedOn;
    } finally {
      this.isLoading = false;
    }
  }

  private async settleStep(step: number): Promise<boolean> {
    if (step !== this.formPagination) {
      // vee-validate only knows the fields currently rendered, so a step has to
      // be on screen before it can be judged.
      this.formName = this.dataStepSlugs[step];
      this.formPagination = step;
      if (this.formName === "renewalTrainingInformation") {
        if (this.renewalPayLoadData.renewalTrainingInformation.length) {
          this.showTrainingForm();
        }
        this.setAvailableTraining();
      }
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 50));
    }
    this.prepareStepForCompletion(step);
    const valid = await this.$validator.validateAll();
    this.$validator.errors.clear();
    if (valid && this.stepExtraChecksPass(step)) {
      this.markStepComplete(step);
      return true;
    }
    if (valid) {
      this.explainStepBlock(step);
    }
    return false;
  }

  // What Next fills in on the applicant's behalf before it will judge a step.
  // The submission date is the whole reason Signature could never be completed
  // by filling the form: it is required, and only Next ever wrote it.
  private prepareStepForCompletion(step: number) {
    if (
      step === this.dataStepSlugs.length - 1 &&
      this.renewalPayLoadData.renewalSignatureSubmission.isSignature
    ) {
      this.renewalPayLoadData.renewalSignatureSubmission.submissionDate =
        moment().format("MM-DD-YYYY");
    }
  }

  // Say out loud why a tab is holding Preview up, in the words Next uses. The
  // conflicts below are invisible to vee-validate, so without this the applicant
  // is bounced back to a tab with every field filled and nothing flagged.
  private explainStepBlock(step: number) {
    if (step === 1) {
      this.trainingDuplicateIndexs = this.duplicateRowIdx(
        "renewalTrainingInformation",
        "trainingName"
      );
      return;
    }
    if (step === 2) {
      this.supervisorEmailDuplicateIndexs = this.duplicateRowIdx(
        "renewalSupervisorInformation",
        "supervisorEmail"
      );
      if (!this.supervisorEmailDuplicateIndexs.length) {
        this.errorMessage =
          "Supervisor email id and applicant email id must be different *";
      }
      return;
    }
    if (step === 3) {
      this.checkSOAValid = !this.checkSOAValid;
      return;
    }
    if (step === this.dataStepSlugs.length - 1) {
      this.signatureInvalid = true;
    }
  }

  // Record a step as completed. The silent pass and the Preview gate both land
  // here so there is one definition of "done" and one write to storage.
  private markStepComplete(step: number) {
    if (!this.formCompletedIndex.includes(step)) {
      this.formCompletedIndex.push(step);
    }
    localStorage.setItem(
      "renewalFormFilledIndex",
      this.formCompletedIndex.toString()
    );
  }

  private async markCurrentStepIfComplete() {
    try {
      await this.deriveCurrentStepCompletion();
    } catch (error) {
      // Judging a step is a convenience. If it throws, the applicant still gets
      // to change tabs — the gate below decides what happens next.
    }
  }

  private async deriveCurrentStepCompletion() {
    const step = this.formPagination;
    if (step >= this.dataStepSlugs.length || this.validatorFieldCount() === 0) {
      return;
    }
    const valid = await this.$validator.validateAll();
    this.$validator.errors.clear();
    const complete =
      valid &&
      !this.notFilesUploadedKeyNames.length &&
      this.stepExtraChecksPass(step);
    const idx = this.formCompletedIndex.indexOf(step);
    if (complete) {
      this.markStepComplete(step);
    } else if (step === 0 && idx !== -1) {
      // Only Basic Details is ever unmarked here, which is what this check was
      // written for: a draft row exists from an email alone, so a stale mark has
      // to be corrected. A later step was marked by Next, which validated the
      // whole tab with everything rendered — a silent re-check that cannot see
      // as much must not be allowed to take that away and strand the applicant
      // on a tab that looks finished.
      this.formCompletedIndex.splice(idx, 1);
      localStorage.setItem(
        "renewalFormFilledIndex",
        this.formCompletedIndex.toString()
      );
    }
  }

  // On load, re-derive step 0 completion once the tab has rendered.
  private async syncStepZeroOnLoad() {
    let tries = 0;
    while (
      tries++ < 30 &&
      (this.formData.length === 0 || this.validatorFieldCount() === 0)
    ) {
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    await this.markCurrentStepIfComplete();
  }

  public nextPaginationUpdate() {
    if (this.formPagination < this.formData.length - 1) {
      this.isNavLoad = true;
      const page = this.formPagination + 1;
      if (page == 0) {
        this.formName = "renewalApplicationInformation";
      } else if (page == 1) {
        this.formName = "renewalTrainingInformation";
        const renewalFormData =
          this.renewalPayLoadData.renewalTrainingInformation;
        if (renewalFormData.length) {
          this.showTrainingForm();
        }
        this.setAvailableTraining();
      } else if (page == 2) {
        this.formName = "renewalSupervisorInformation";
      } else if (page == 3) {
        this.formName = "renewalHandbook";
      } else if (page == 4) {
        this.formName = "renewalSignatureSubmission";
      }
      this.formPagination = page;
    }
  }

  public previousButton() {
    this.notFilesUploadedKeyNames = [];
    this.supervisorEmailDuplicateIndexs = [];
    this.isEdit = false;
    if (this.formPagination !== 0) {
      const el = document.getElementById(this.mainId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "end" });
      }
      this.formPagination = this.formPagination - 1;
      if (this.formPagination == 0) {
        this.formName = "renewalApplicationInformation";
      } else if (this.formPagination == 1) {
        this.formName = "renewalTrainingInformation";
        const renewalFormData =
          this.renewalPayLoadData.renewalTrainingInformation;
        if (renewalFormData.length) {
          this.showTrainingForm();
        }
        this.setAvailableTraining();
      } else if (this.formPagination == 2) {
        this.formName = "renewalSupervisorInformation";
      } else if (this.formPagination == 3) {
        this.formName = "renewalHandbook";
      } else if (this.formPagination == 4) {
        this.formName = "renewalSignatureSubmission";
      }
    }
  }
  public onSubmit() {
    this.$validator.validate().then((validate) => {
      if (validate) {
        this.renewalPayLoadData.renewalApplicationInformation.state =
          this.renewalPayLoadData.renewalApplicationInformation.state.toLocaleUpperCase();
        this.renewalPayLoadData.renewalSignatureSubmission.submissionDate =
          moment().format("MM-DD-YYYY");
        this.isLoading = true;
        let payloadStorage: any = localStorage.getItem("renewalPayLoadData");
        if (payloadStorage) {
          payloadStorage = JSON.parse(payloadStorage);
          this.renewalPayLoadData = {
            ...this.renewalPayLoadData,
            ...payloadStorage,
          };
        }
        this.stopDraftAutoSave();
        this.renewalPayLoadData.fillStatus = "COMPLETED";
        if (localStorage.getItem("renewalApplicationId")) {
          this.renewalPayLoadData.id = localStorage.getItem(
            "renewalApplicationId"
          );
        }
        renewalFormApi
          .updateRenewalForm(
            this.renewalPayLoadData,
            this.renewalPayLoadData.id
          )
          .then(() => {
            const someData = {
              title: "Certified Peer Recovery Specialist Application",
              SubTitle: "Renewal Application",
            };
            this.$router.push({
              path: "/form/submitted",
              query: { subTitle: someData.SubTitle },
            });
            this.isLoading = false;
            const el = document.getElementById(this.mainId);
            if (el) {
              el.scrollIntoView({ behavior: "smooth", block: "end" });
            }
            localStorage.removeItem("renewalFormFilledIndex");
            localStorage.removeItem("renewalPayLoadData");
            localStorage.removeItem("renewalApplicationId");
          })
          .catch((error) => {
            this.errorMessage = utils.errorMessage(error);
            this.isLoading = false;
          });
      }
    });
  }

  public saveDraft() {
    this.$bvToast.show("example-toast");
    this.isValid = true;
    // Save Draft is a deliberate save, so it reaches the server too - the
    // button says draft saved, and until now it only ever wrote this browser.
    this.persistDraft();
    localStorage.setItem(
      "renewalPayLoadData",
      JSON.stringify(this.renewalPayLoadData)
    );
    this.saveDataDraft = true;
    setTimeout(() => {
      this.saveDataDraft = false;
    }, 1000);
  }

  public closeToast() {
    this.$bvToast.hide("example-toast");
  }

  public showTrainingForm() {
    const renewalFormData = this.renewalPayLoadData.renewalTrainingInformation;
    if (renewalFormData.length) {
      this.addTrainingForm = [];
      this.renewalPayLoadData.renewalTrainingInformation =
        renewalFormData.filter((data: any) => {
          if (this.educationLists && this.educationLists.length) {
            this.educationLists.filter((education: any) => {
              if (
                data.id === education.id ||
                data.trainingName === education.trainingName
              ) {
                education.isChecked = true;
              }
            });
          }
          return data.isNew;
        });
      this.renewalPayLoadData.renewalTrainingInformation.forEach(() => {
        this.addTrainingForm.push(this.formData[1].fields.formInputs);
      });
    }
  }

  public formEdit(slug: any) {
    this.isEdit = true;
    this.formName = slug;
    if (slug == "renewalApplicationInformation") {
      this.formPagination = 0;
    } else if (slug == "renewalTrainingInformation") {
      const renewalFormData =
        this.renewalPayLoadData.renewalTrainingInformation;
      if (renewalFormData.length) {
        this.showTrainingForm();
      }
      this.formPagination = 1;
    } else if (slug == "renewalSupervisorInformation") {
      this.formPagination = 2;
    } else if (slug == "renewalHandbook") {
      this.formPagination = 3;
    } else if (slug == "renewalSignatureSubmission") {
      this.renewalPayLoadData.renewalSignatureSubmission.isSignature = "";
      localStorage.setItem(
        "renewalPayLoadData",
        JSON.stringify(this.renewalPayLoadData)
      );
      this.formPagination = 4;
    }
    const el = document.getElementById(this.mainId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }

  public pushTrainingForm() {
    this.addTrainingForm.push(this.formData[1].fields.formInputs);
    this.renewalPayLoadData.renewalTrainingInformation =
      this.renewalPayLoadData.renewalTrainingInformation.filter((data: any) => {
        return data.isNew;
      });
    this.renewalPayLoadData.renewalTrainingInformation.push({
      trainingName: "",
      trainingDuration: "",
      trainingFormat: "",
      isNew: true,
      proofOfAttendance: [],
    });
    localStorage.setItem(
      "renewalPayLoadData",
      JSON.stringify(this.renewalPayLoadData)
    );
  }

  public addTraining() {
    this.isFileValid = !this.isFileValid;
    const renewalFormData = this.renewalPayLoadData.renewalTrainingInformation;
    if (renewalFormData.length && !this.isAvailableTraining) {
      this.$validator.validateAll().then((validate) => {
        if (validate && !this.notFilesUploadedKeyNames.length) {
          if (this.addTrainingForm.length) {
            this.pushTrainingForm();
          }
        } else {
          setTimeout(() => {
            const el = document.getElementsByClassName("is-invalid")[0];
            if (el) {
              el.scrollIntoView({ behavior: "smooth", block: "end" });
            }
          }, 10);
        }
      });
    } else {
      this.pushTrainingForm();
    }
  }

  public removeTraining(index: number) {
    this.notFilesUploadedKeyNames = [];
    this.isTrainingReferesh = this.changeStateForTraining(
      this.isTrainingReferesh
    );
    this.renewalPayLoadData.renewalTrainingInformation.splice(index, 1);
    this.addTrainingForm.splice(index, 1);
    this.showTrainingForm();
    this.setAvailableTraining();
    localStorage.setItem(
      "renewalPayLoadData",
      JSON.stringify(this.renewalPayLoadData)
    );
    setTimeout(() => {
      this.isTrainingReferesh = this.changeStateForTraining(
        this.isTrainingReferesh
      );
    }, 10);
  }

  public changeStateForTraining(value: string) {
    if (value === "false") {
      return "true";
    } else {
      return "false";
    }
  }

  public numberValidation(evt: any, length?: number) {
    utils.onlyNumberKey(evt, length);
  }

  public telCharacterValidate(evt: any, length?: number) {
    utils.telCharacterValidate(evt, length);
  }

  public onlyAlphabets(evt: any, fieldName = "") {
    utils.onlyAlphabets(evt, fieldName);
  }

  public fieldValidation(
    value: any,
    eventName: string,
    fieldType: string,
    maxLength = 0,
    fieldName = ""
  ) {
    if (fieldType === "number") {
      this.eventBind[eventName](value, maxLength);
    } else if (fieldName === "state") {
      this.eventBind[eventName](value, fieldName);
    } else {
      this.eventBind[eventName](value);
    }
  }

  public emptyEvent() {
    return;
  }

  public allFilesUploaded(event: any) {
    if (this.notFilesUploadedKeyNames.includes(event)) {
      this.notFilesUploadedKeyNames.splice(event, 1);
    }
  }

  public notFileUploaded(event: string) {
    if (!this.notFilesUploadedKeyNames.includes(event)) {
      this.notFilesUploadedKeyNames.push(event);
    }
  }

  public resetFileKey(event: boolean) {
    if (event) {
      this.notFilesUploadedKeyNames = [];
    }
  }

  /**
   * The payload section the rendered step edits. The template must never index
   * the payload directly: Preview is a step with no section of its own, and a
   * draft restored from an older shape can be missing one — either way an
   * undefined section throws on every render, which blanks the form and fills
   * the console rather than showing the step.
   */
  get currentSection() {
    return this.renewalPayLoadData[this.formName] || {};
  }

  public async navigateTab(slug: string, index: number) {
    if (index === this.formPagination) {
      return;
    }
    // Leaving a data step: mark it complete only if fully valid, so the Preview
    // gate sees a tab the applicant finished and left by clicking another tab,
    // Next or no Next. Jumping away from an unfinished tab is allowed — it just
    // does not get marked complete.
    await this.markCurrentStepIfComplete();
    // Reaching Preview requires every data step completed. If any is incomplete,
    // jump to the first one instead.
    if (index === this.dataStepSlugs.length) {
      const blocked = await this.settleIncompleteSteps();
      if (blocked !== -1) {
        this.jumpToIncompleteStep(blocked);
        this.announceBlockedStep(blocked);
        return;
      }
    }
    this.isEdit = false;
    // Auto-save the current part as a draft before leaving it.
    this.persistDraft();
    // Preview has no payload section of its own, but the step still owns the
    // slug: the template decides which block to render from formName, so
    // pinning it to the previous step rendered that step's fields on the
    // Preview tab. Nothing may index the payload by formName without a
    // fallback — the currentSection getter is what keeps an absent section
    // from throwing.
    this.formName = slug;
    this.formPagination = index;
    // Keyed off the slug, not formName: formName now stays on the last data
    // step when Preview is the destination, and Preview must not re-prepare the
    // training tab it is leaving.
    if (slug === "renewalTrainingInformation") {
      const renewalFormData =
        this.renewalPayLoadData.renewalTrainingInformation;
      if (renewalFormData.length) {
        this.showTrainingForm();
      }
      this.setAvailableTraining();
    }
    const el = document.getElementById(this.mainId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }

  // Persist the current payload as a draft (fillStatus stays DRAFT) without
  // validation — used when jumping between parts. The row already exists.
  // Draft saves are chained rather than fired in parallel: navigateTab does not
  // await this (the tab switches immediately), so jumping several tabs quickly
  // would otherwise leave overlapping PUTs racing, and the last response to
  // land wins regardless of the order they were sent.
  private draftSave: Promise<void> = Promise.resolve();

  /*
   * The local half on its own. Typing writes here and nowhere else: keystrokes
   * are not an instruction to save, and a request per field is both wasted and
   * a way for a half-typed value to be judged by the API before the applicant
   * has finished it. The server is written on the deliberate actions instead -
   * changing tab, Next, and Save Draft.
   */
  private saveDraftLocally() {
    localStorage.setItem(
      "renewalPayLoadData",
      JSON.stringify(this.renewalPayLoadData)
    );
  }

  public persistDraft(): Promise<void> {
    this.draftSave = this.draftSave.then(() => this.saveDraftNow());
    return this.draftSave;
  }

  /**
   * Store the draft. The local copy is written unconditionally, so progress
   * survives a reload from the very first field the applicant fills.
   *
   * The server copy needs two things here: fetchDetailsfromData() in the
   * workflow API rejects a renewal save without a valid email AND without a
   * certificate number ("No certificate number provided"), so the row is created
   * only once both exist, and updated on every save after that. Before then the
   * draft is local-only, which is silent by design — a failed autosave the
   * applicant did not ask for is not something they can act on.
   */
  private async saveDraftNow() {
    localStorage.setItem(
      "renewalPayLoadData",
      JSON.stringify(this.renewalPayLoadData)
    );
    const info = this.renewalPayLoadData.renewalApplicationInformation;
    if (!this.renewalPayLoadData.id) {
      if (
        !utils.canSaveDraftRemotely(info.email) ||
        !info.certificationNumber
      ) {
        return;
      }
      try {
        const result: any = await renewalFormApi.RenewalApplicationForm(
          this.renewalPayLoadData.fillStatus,
          this.renewalPayLoadData
        );
        this.renewalLocationId = result.headers.location;
        localStorage.setItem("renewalApplicationId", this.renewalLocationId);
        this.renewalPayLoadData.id = this.renewalLocationId;
        localStorage.setItem(
          "renewalPayLoadData",
          JSON.stringify(this.renewalPayLoadData)
        );
      } catch (error) {
        // Kept quiet: an autosave the applicant did not ask for should not throw
        // a popup over the field they are typing in. The local copy above still
        // holds everything, and Next surfaces the real error when they submit.
      }
      return;
    }
    try {
      await renewalFormApi.updateRenewalForm(
        this.renewalPayLoadData,
        this.renewalPayLoadData.id
      );
    } catch (error) {
      this.errorMessage = utils.errorMessage(error);
    }
  }

  // Debounced autosave, armed once the form has finished loading so the CMS
  // render and the applicant prefill do not count as filling anything in. From
  // the first real keystroke every change is persisted.
  private draftAutoSaveTimer: any = null;

  private queueDraftSave() {
    if (this.draftAutoSaveTimer) {
      clearTimeout(this.draftAutoSaveTimer);
    }
    this.draftAutoSaveTimer = setTimeout(() => {
      this.draftAutoSaveTimer = null;
      this.saveDraftLocally();
    }, 1000);
  }

  private draftWatchStop: any = null;

  private startDraftAutoSave() {
    this.draftWatchStop = this.$watch(
      "renewalPayLoadData",
      () => {
        // Errors are raised by an action - Next, or the bounce to an
        // incomplete step - and dismissed the moment the applicant starts
        // answering them. Without this the gate stays open after a failed
        // Next and vee-validate re-runs on every keystroke, so typing an
        // email is marked invalid letter by letter until it happens to be
        // complete. They are shown again by the next Next.
        this.checkValidForm = false;
        this.queueDraftSave();
      },
      { deep: true }
    );
  }

  /*
   * Submitting ends the draft. The payload is still mutated on the way out -
   * fillStatus, the signature date, the id read back from storage - and each
   * of those fires the watcher above, queueing a local write. onSubmit then
   * clears the stored draft, and the queued write lands a second later and
   * puts it straight back, so the next application opens on the submitted
   * one's data. Stop the watcher and drop anything pending before the submit
   * runs, so no write can outlive it.
   */
  private stopDraftAutoSave() {
    if (this.draftWatchStop) {
      this.draftWatchStop();
      this.draftWatchStop = null;
    }
    if (this.draftAutoSaveTimer) {
      clearTimeout(this.draftAutoSaveTimer);
      this.draftAutoSaveTimer = null;
    }
  }

  public beforeDestroy() {
    this.stopDraftAutoSave();
  }

  public addAnother() {
    this.renewalPayLoadData.renewalSupervisorInformation.push({
      supervisorFirstName: "",
      supervisorLastName: "",
      supervisorAgencyOrganization: "",
      supervisorPhone: "",
      supervisorEmail: "",
    });
    this.supervisorFormFields.push(this.tempSupervisorFormFields);
    this.supervisorUIUpdate = utils.UIUpdateUsingKey(this.supervisorUIUpdate);
  }

  public removeAddedSupervisor(indexForm: number) {
    this.renewalPayLoadData.renewalSupervisorInformation.splice(indexForm, 1);
    this.supervisorFormFields.splice(indexForm, 1);
    this.supervisorUIUpdate = utils.UIUpdateUsingKey(this.supervisorUIUpdate);
  }

  public classNameChooser(inputClass: string) {
    return utils.classNameChooser(inputClass);
  }

  public closdedErrorPopup(event: any) {
    if (event) {
      this.errorMessage = "";
    }
  }
  public goBack() {
    if (this.$route.query.isDraft) {
      localStorage.removeItem("renewalPayLoadData");
    }
    this.$router.push({
      path: `/application`,
      query: {
        form: "renewal",
      },
    });
    const el = document.getElementById("header");
    if (el) {
      el.classList.add("active");
      el.classList.remove("remove-container");
    }
  }
  public getTraningDetail() {
    applicantDetialsApi
      .getContinuingEducation()
      .then((result) => {
        this.educationLists = result.data.educations;
        this.educationLists = this.educationLists.filter((item: any) => {
          item.trainingDate = item.trainingDate
            ? moment(item.trainingDate).format("MM-DD-YYYY")
            : null;
          item.trainingName = item.title;
          return item.isArchived === false;
        });
        this.isLoading = false;
        if (this.renewalPayLoadData) {
          this.renewalPayLoadData?.renewalTrainingInformation?.filter(
            (training: any) => {
              this.educationLists.filter((education: any) => {
                if (training.id === education.id) {
                  education.isChecked = true;
                }
              });
            }
          );
        }
      })
      .catch((error) => {
        this.errorMessage = utils.errorMessage(error);
        this.isLoading = false;
      });
  }
  public checked(training: any) {
    this.isAvailableTraining = true;
    if (training.isChecked) {
      this.availableTraining.push(training);
    } else {
      this.availableTraining = this.availableTraining.filter(
        (item: any) => item.id !== training.id
      );
    }
  }
  public previewForm(rowData: any) {
    rowData.attachments.forEach((item: any) => {
      item.uploadedFileName = item.fileName;
      const temp = JSON.parse(JSON.stringify(item));
      const previewData = temp;
      if (this.imgType.includes(previewData.uploadedFileName.split(".")[1])) {
        const img = new Image();
        img.src = `${this.S3Path}/${previewData.uploadedFileName}`;
        previewData.width = img.width;
        previewData.height = img.height;
      }
      if (!this.previewFile.length) {
        this.previewFile = [previewData];
      } else {
        this.previewFile.push(previewData);
      }
      this.showPreviewPopup = true;
    });
  }
  public hidePreviewPopup(event: boolean) {
    if (event === true) {
      this.showPreviewPopup = false;
      this.previewFile = [];
    }
  }
  public showMore(type: boolean) {
    this.isLoading = true;
    if (type) {
      this.trainingIndex = 2;
    } else {
      this.trainingIndex = this.trainingIndex + 3;
    }
    setTimeout(() => {
      this.isLoading = false;
    }, 1000);
  }
  public setAvailableTraining() {
    this.renewalPayLoadData.renewalTrainingInformation =
      this.renewalPayLoadData.renewalTrainingInformation.filter((data: any) => {
        return data.isNew;
      });
    if (this.educationLists.length) {
      this.educationLists.filter((traning: any) => {
        if (traning.isChecked) {
          const data = {
            trainingName: traning.title,
            proofOfAttendance: traning.attachments,
            trainingDuration: traning.trainingHours,
            trainingFormat:
              traning && traning.trainingFormat ? traning.trainingFormat : "",
            isNew: false,
            isChecked: traning.isChecked,
          };
          this.renewalPayLoadData.renewalTrainingInformation.push(data);
        }
      });
    }
  }
}
